import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurationsComponent } from './configurations.component';
import { ConfigurationsRoutingModule } from './configurations-routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { BBSFControlsModule } from 'bbsf-controls';
import { BlockUIModule } from 'ng-block-ui';
import { AuthModule } from '../core/auth.module';
import { ConfigurationComponent } from './configuration/configuration.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatMenuModule } from '@angular/material/menu';
import { InlineSVGModule } from 'ng-inline-svg';
import { AuthService, BBSFTranslateService, BBSFUtilitiesModule, EnvironmentService, UtilityService } from 'bbsf-utilities';
import { EmptyDataModule } from '../empty-data/empty-data.module';
import { ConfigurationsService } from '../shared/Services/ConfigurationsService.service';




@NgModule({
  declarations: [ConfigurationsComponent, ConfigurationComponent],
  imports: [
    ConfigurationsRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    AuthModule,
    RouterModule,
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    BBSFControlsModule,
    NgbModule,
    MatMenuModule,
    InlineSVGModule,
    BBSFUtilitiesModule,
    EmptyDataModule
  ],
  providers:[
    EnvironmentService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
    ConfigurationsService
  ]
})
export class ConfigurationsModule { }
